import { render, staticRenderFns } from "./PunchWay.vue?vue&type=template&id=c9ce64b4&scoped=true&"
import script from "./PunchWay.vue?vue&type=script&lang=js&"
export * from "./PunchWay.vue?vue&type=script&lang=js&"
import style0 from "./PunchWay.vue?vue&type=style&index=0&id=c9ce64b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ce64b4",
  null
  
)

export default component.exports